import { api } from '@here/api'

export const handleGetMessageMentions = async (userId: string) => {
	const { data } = await api().from('message_mention').select('*').eq('user_id', userId)

	return data || []
}

export const handleDeleteMessageMention = async (id: string) => {
	const { error } = await api().from('message_mention').delete().eq('id', id)

	if (error) {
		console.error('Failed to delete message:', error)
		throw error
	}

	return id
}
